require('./lbCurrencyMessage.scss');

const lbCurrencyMessage = angular.module('app.lbCurrencyMessage', []);

lbCurrencyMessage.component('lbCurrencyMessage', {
  bindings: {
    mode: '<',
  },
  controllerAs: 'vm',
  controller: ['settingsService', controller],
  template: require('./lbCurrencyMessage.html')
});

function controller(settingsService) {

  let vm = this;

  vm.currencyCode = settingsService.settings.Currency.Code;
  vm.message = `ALL PRICES SHOWN HERE IN ${vm.currencyCode} BASED ON THE CURRENT EXCHANGE RATES WE HAVE ON RECORD`;

}

export default lbCurrencyMessage;



// WEBPACK FOOTER //
// ./src/components/lbCurrencyMessage/lbCurrencyMessage.js